module.exports = __webpack_public_path__ + "img/08_fruit list 2.38ec531c.png";